// ROUTERS
import CatalogueRouter from './CatalogueRouter';
import Extension from './ExtensionRouter';

// VIEWS
const CatalogueView = () => import('../views/Catalogue/CatalogueView');
const CatalogueSetView = () => import('../views/Catalogue/CatalogueSetView');
const ProjectTokenView = () => import('../views/ProjectTokenView');
const MainView = () => import('../views/MainView');
const InterestView = () => import('../views/InterestView');
const NewsletterView = () => import('../views/NewsletterView');
const WidgetView = () => import('../views/WidgetView');

export default [
    {
        path:      'e',
        component: Extension,
        children:  [
            {
                path:      'default',
                name:      'project-extension',
                component: MainView,
            }, {
                path:      'catalogue',
                component: CatalogueRouter,
                children:  [
                    {
                        path:      '',
                        name:      'project-extension-catalogue',
                        component: CatalogueView,
                    }, {
                        path:      'set/:catalogueId',
                        name:      'project-extension-catalogue-set',
                        component: CatalogueSetView,
                    }
                ]
            }, {
                path:      'project-token',
                name:      'project-token',
                component: ProjectTokenView,
            }, {
                path:      'extension-interest',
                name:      'extension-interest',
                component: InterestView,
            }, {
                path:      'extension-newsletter',
                name:      'extension-newsletter',
                component: NewsletterView,
            }, {
                path:      'extension-widget',
                name:      'extension-widget',
                component: WidgetView,
            }
        ]
    }
]
